import api from "./index";

export async function getGames(params) {
  return api.get("/games", { params });
}

export async function getGamesAvailable(params) {
  return api.get("/games/available", { params });
}
